/* global globalThis */
import { COLLECTION_API_ORIGIN } from "./collectionV2.js";

const parse = (value, fallback) => { try { return JSON.parse(value) || fallback; } catch { return fallback; } };
export const withdrawalRecoveryEntries = () => {
    const storage = globalThis.localStorage;
    const withdrawn = parse(storage.getItem("pure_collection_deletion_receipts_v3"), {});
    const credentials = parse(storage.getItem("pure_collection_participant_tokens_v1"), {});
    const entries = new Map();
    const append = (participant_id, token, receipt) => {
        if (/^participant_[0-9a-f]{32}$/.test(participant_id || "") && /^[A-Za-z0-9_-]{43,128}$/.test(token || "") && (receipt?.deletion_request_id || receipt?.server_confirmed === true)) {
            entries.set(participant_id, { participant_id, token, receipt });
        }
    };
    Object.entries(credentials).forEach(([key, token]) => {
        const participant_id = key.slice(key.lastIndexOf(":") + 1);
        append(participant_id, token, withdrawn[participant_id]);
    });
    const current = parse(storage.getItem("pure_collection_withdrawal_v3"), null);
    for (let i = 0; i < storage.length; i++) {
        const key = storage.key(i);
        if (key?.startsWith("pure_collection_participant_token_v1:")) {
            const credential = parse(storage.getItem(key), {});
            if (current?.participant_id === credential.participant_id) append(credential.participant_id, credential.token, current);
        }
    }
    const history = parse(storage.getItem("pure_collection_withdrawal_credentials_v1"), []);
    if (Array.isArray(history)) history.forEach(item => append(item.participant_id, parse(item.credential, {}).token, item.receipt));
    return [...entries.values()];
};

export const retryRecordedWithdrawal = async participantId => {
    const entry = withdrawalRecoveryEntries().find(item => item.participant_id === participantId);
    if (!entry) throw new Error("No private withdrawal credential is available for this record.");
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 30000);
    try {
        const response = await fetch(`${COLLECTION_API_ORIGIN}/api/v2/participants/${participantId}/data`, {
            method: "DELETE", signal: controller.signal,
            headers: { "Content-Type": "application/json", "X-Participant-Token": entry.token,
                "Idempotency-Key": "withdrawal_followup_" + globalThis.crypto.randomUUID() },
            body: JSON.stringify({ reason: "consent_withdrawal", scope: "all" }),
        });
        const result = await response.json();
        if (!response.ok || !result.deletion_request_id) throw new Error("The follow-up request was not confirmed. Keep your existing receipt and retry.");
        return result;
    } finally { clearTimeout(timeout); }
};
